<template>
  <span class="text-xs text-primary font-bold bg-secondary-dark/30 rounded-full px-4 py-2"><slot /></span>
</template>
